import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateReturnsFlag } from '../../store/create-label-content/create-label-content.actions';

export const useIsReturnState = (fulfillmentPlanId, onConfigurationChange) => {
  const dispatch = useDispatch();

  const onIsReturnChanged = useCallback(
    (isReturn) => {
      dispatch(updateReturnsFlag(fulfillmentPlanId, isReturn));
      onConfigurationChange({ isReturn });
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  return {
    onIsReturnChanged,
  };
};
